import { UserType } from "../types/airgraft";

function loadAndStubIntercom() {
  const isSSR = typeof window === "undefined";
  const appId = process.env.GATSBY_INTERCOM_APP_ID;

  const stubIntercom = (...args) => {
    stubIntercom.c(args);
  };
  stubIntercom.q = [];
  stubIntercom.c = args => {
    stubIntercom.q.push(args);
  };

  if (isSSR || !appId) {
    return stubIntercom;
  }

  if (typeof window.Intercom === "function") {
    // basic initialize command
    // https://developers.intercom.com/installing-intercom/docs/basic-javascript
    if (!window.Intercom.booted) {
      window.Intercom("reattach_activator");
      window.Intercom("update", window.intercomSettings);
    }
    return window.Intercom;
  } else {
    // basic initialize stub
    window.Intercom = stubIntercom;
    // load script
    const l = function() {
      const s = window.document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${appId}`;
      const x = window.document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === "complete") {
      l();
    } else if (window["attachEvent"]) {
      window["attachEvent"]("onload", l);
    } else {
      window.addEventListener("load", l, false);
    }
  }
}

function bootstrapIntercomWithUserProfile({
  phoneNumber,
  email,
  accessChatToken,
  givenName,
  uuid
}: UserType) {
  const extraUserData = {};
  if (phoneNumber) {
    extraUserData["phone"] = phoneNumber;
  }
  if (email) {
    extraUserData["email"] = email;
    extraUserData["name"] = email;
  }
  if (givenName) {
    extraUserData["name"] = givenName;
  }
  if (window.Intercom.booted) {
    window.Intercom("update", {
      ...extraUserData,
      user_hash: accessChatToken,
      user_id: uuid
    });
  } else {
    window.Intercom("boot", {
      ...extraUserData,
      app_id: process.env.GATSBY_INTERCOM_APP_ID,
      hide_default_launcher: true,
      user_hash: accessChatToken,
      user_id: uuid
    });
  }
}

function bootstrapIntercomWithAnonymous() {
  window.Intercom("shutdown");
  window.Intercom("boot", {
    app_id: process.env.GATSBY_INTERCOM_APP_ID,
    hide_default_launcher: true
  });
}

export function showIntercom(user: UserType) {
  loadAndStubIntercom();
  if (user?.accessChatToken) {
    bootstrapIntercomWithUserProfile(user);
  } else {
    bootstrapIntercomWithAnonymous();
  }
  window.Intercom("show");
}
